import { CLASSROOM_MODULE_HIDEUNHIDE_MATERIAL } from '../actions';
import { patchSection, patchFolder } from '../api';
import { getMaterial, currentSection } from '../selectors';
import { AulaReduxAction, AulaState, AulaDispatch } from '../../types/state';
import { getCurrentSpaceId } from '../../selectors/space';
import { Material } from '../types';
import { ActionStatus } from '../../constants/actionsStatus';
import { isLocalId } from '../../utils/localId';

const changeVisibilityAction = (status: ActionStatus, payload: unknown) => ({
  type: CLASSROOM_MODULE_HIDEUNHIDE_MATERIAL,
  status,
  payload,
});

const changeVisibility = async (
  dispatch: AulaDispatch,
  state: AulaState,
  material: Material,
  hidden: boolean,
  educatorOnly?: boolean
) => {
  const classRoom = getCurrentSpaceId(state);
  const optimisticPatch = { ...material, hidden };

  dispatch(changeVisibilityAction('started', { materialId: material.id }));
  try {
    const patch = {
      hidden,
      scheduledFor: null,
    };
    const updatedMaterial = !isLocalId(material.id)
      ? await (material.isFolder
          ? patchFolder(classRoom, material.id, patch, undefined, educatorOnly)
          : patchSection(
              classRoom,
              material.id,
              patch,
              undefined,
              undefined,
              educatorOnly
            ))
      : optimisticPatch;
    dispatch(changeVisibilityAction('success', { updatedMaterial }));
  } catch (error) {
    dispatch(changeVisibilityAction('error', error));
  }
};

type HideMaterialActionFactory = (
  materialId?: string,
  educatorOnly?: boolean
) => AulaReduxAction;
type UnhideMaterialActionFactory = (
  materialId: string,
  educatorOnly?: boolean
) => AulaReduxAction;

export const hideMaterial: HideMaterialActionFactory =
  (materialId, educatorOnly) => async (dispatch, getState) => {
    const state = getState();
    const material = materialId
      ? getMaterial(state, materialId)
      : currentSection(state);
    if (!material) {
      return;
    }

    await changeVisibility(dispatch, state, material, true, educatorOnly);
  };

export const unHideMaterial: UnhideMaterialActionFactory =
  (materialId, educatorOnly) => async (dispatch, getState) => {
    const state = getState();
    const material = getMaterial(state, materialId);
    if (!material) {
      return;
    }

    await changeVisibility(dispatch, state, material, false, educatorOnly);
  };
